import cartAtom from "@/atoms/cart";
import { showToast } from "@/components/feedback";
import { errorMessage } from "@/lib/i18n/error-messages";
import {
  CART_TTL_CHECK_INTERVAL_MS,
  isStoredCartExpired,
} from "@/lib/cart-local-storage";
import { useAtomValue } from "jotai";
import { useCallback, useEffect } from "react";
import { recordStorefrontCartCleared } from "@/domain/storefront-analytics";
import { useOptimisticCart } from "./use-optimistic-cart";

export function useCartTtlGuard() {
  const cart = useAtomValue(cartAtom);
  const { clearAfterCheckout } = useOptimisticCart();
  const itemCount = cart.items.length;

  const discardIfExpired = useCallback(async () => {
    if (itemCount === 0) return;
    if (!isStoredCartExpired()) return;
    recordStorefrontCartCleared("ttl");
    showToast.warning(errorMessage("cartNotFound"), { title: "Sacola expirada" });
    await clearAfterCheckout();
  }, [itemCount, clearAfterCheckout]);

  useEffect(() => {
    void discardIfExpired();

    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        void discardIfExpired();
      }
    };
    document.addEventListener("visibilitychange", onVisibility);
    const intervalId = window.setInterval(() => {
      void discardIfExpired();
    }, CART_TTL_CHECK_INTERVAL_MS);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.clearInterval(intervalId);
    };
  }, [discardIfExpired]);
}
